import { useCSRFToken } from "components/hooks/useCSRFToken";
import { CalCentralAPI } from "utils/CalCentralAPI";

export function useAPI() {
  const csrfToken = useCSRFToken();
  const api = new CalCentralAPI(csrfToken);

  api.csrfToken = csrfToken;

  return api;
}
